export const connectedAgentsPtBr = {
  page: {
    loadError: {
      title: 'Falha ao carregar agentes conectados',
      description: 'Atualize a página e tente novamente.',
    },
    title: 'Agentes de IA conectados',
    description:
      'Agentes de IA (Claude, ChatGPT e outros) que se conectam aos seus dados via MCP. Aprove um agente e escolha quais grupos de ferramentas ele pode usar. O acesso também é sempre limitado pelas permissões do próprio usuário conectado.',
    catalogLink: 'Ver catálogo MCP',
    enforcementOff: {
      title: 'A aplicação por agente está desativada',
      description:
        'As alterações aqui são salvas, mas ainda não são aplicadas para esta organização. Ative a aplicação por agente para exigir aprovação antes que um agente possa usar uma ferramenta.',
    },
    empty:
      'Nenhum agente se conectou ainda. Quando um agente de IA se conectar via MCP, ele aparecerá aqui para revisão.',
    pendingBanner: {
      title_one: '1 agente aguardando revisão',
      title_other: '{{count}} agentes aguardando revisão',
      description:
        'Revise as permissões solicitadas abaixo e aprove ou remova cada nova conexão. Até ser aprovado, um agente pendente não pode usar seus dados quando a aplicação está ativa.',
    },
    table: {
      agent: 'Usuário e cliente',
      status: 'Status',
      allowedTools: 'Ferramentas permitidas',
      lastSeen: 'Visto por último',
      actions: 'Ações',
    },
    noEligibleTools: 'Nenhuma ferramenta disponível para esta conexão.',
    lastScopeRequired: 'Um agente aprovado precisa manter pelo menos uma ferramenta.',
    status: {
      pending: 'pendente',
      approved: 'aprovado',
      revoked: 'revogado',
    },
    actions: {
      approve: 'Aprovar',
      revoke: 'Revogar',
      remove: 'Remover',
    },
    remove: {
      title: 'Remover {{name}}?',
      description:
        'Isso esquece a conexão e exclui suas permissões salvas. Se o mesmo agente se conectar novamente, ele reaparecerá aqui para revisão. Para bloquear permanentemente um agente mantendo o histórico, use Revogar.',
      cancel: 'Cancelar',
      confirm: 'Remover',
    },
    displayName: {
      session: 'Cliente MCP (sessão)',
      generic: 'Cliente MCP',
    },
    legacyUser: 'Usuário não identificado',
    legacyConnection: 'Conexão legada — reconecte o cliente',
    toast: {
      updated: 'Agente conectado atualizado',
      updateError: 'Não foi possível atualizar o agente conectado',
      removed: 'Agente conectado removido',
      removeError: 'Não foi possível remover o agente conectado',
    },
  },
  connect: {
    title: 'Conectar um novo agente',
    description:
      'Conecte o ChatGPT ou o Claude ao seu ERP. Você fará login com sua conta Alchemy e aprovará o acesso — o agente então aparece abaixo para revisão.',
    mcpUrlLabel: 'URL do servidor MCP',
    copy: 'Copiar',
    copied: 'URL do MCP copiada',
    copyError: 'Não foi possível copiar — selecione e copie manualmente',
    authNotConfigured:
      'Observação: o servidor de autorização ainda não está totalmente configurado neste ambiente.',
    urlNotConfigured: {
      title: 'URL do MCP não configurada',
      description:
        'Peça ao seu administrador para configurar a URL do servidor MCP deste ambiente.',
    },
    steps: {
      open: 'Abra o {{product}} → Configurações → Conectores.',
      add: 'Adicione um conector personalizado e cole a URL do MCP acima.',
      signIn: 'Faça login com sua conta Alchemy e aprove o acesso.',
    },
    openConnectors: 'Abrir conectores do {{product}}',
  },
  consent: {
    invalidLink: {
      title: 'Link de conexão inválido',
      description:
        'Esta página é aberta automaticamente quando você conecta um agente de IA. Inicie a conexão a partir do seu cliente de IA (ChatGPT ou Claude).',
    },
    title: 'Autorizar agente de IA',
    description:
      'Você está conectado com sua conta Alchemy. Estes são os grupos de ferramentas que um agente de IA pode solicitar.',
    requestedPermissions: 'Permissões disponíveis',
    catalogNote:
      'Esta é a lista completa de ferramentas que o MCP oferece. O que cada agente realmente pode usar é controlado por você após a conexão.',
    axis: { question: 'Por pergunta', domain: 'Por domínio', writes: 'Escritas' },
    catalogEmpty: 'Nenhuma ferramenta catalogada para este acesso.',
    catalogError: 'Não foi possível carregar o catálogo.',
    missingAccess: 'Ainda falta liberar',
    details: 'Ver detalhes',
    sampleQuestions: 'Perguntas de exemplo',
    effect: 'Efeito',
    effects: {
      READS_DATA: 'Somente leitura',
      CHANGES_DATA: 'Altera dados',
      MOVES_MONEY: 'Move dinheiro',
    },
    limits: 'Limites',
    knownGaps: 'Lacunas conhecidas',
    expansions: 'Expansões',
    composesWith: 'Combina com',
    resolvesIdsVia: 'Resolve identificadores por',
    inputSchema: 'Entradas',
    outputSchema: 'Retorno',
    domains: 'Domínios',
    domainLabels: {
      guide: 'Guia MCP',
      ap: 'Contas a pagar',
      ar: 'Contas a receber',
      billing: 'Faturamento',
      budget: 'Orçamento',
      cashflow: 'Fluxo de caixa',
      fpa: 'FP&A',
      gl: 'Contábil',
      identity: 'Identidade e usuários',
      org: 'Organização',
    },
    allTools: 'Todas',
    tools: 'Ferramentas',
    toolsCount_one: '{{count}} ferramenta',
    toolsCount_other: '{{count}} ferramentas',
    accessGranted: 'Você tem acesso',
    selectTool: 'Selecione uma ferramenta',
    selectToolDescription: 'Escolha uma ferramenta para consultar a referência completa.',
    emptyField: 'Não informado no catálogo',
    search: 'Buscar por nome, pergunta ou domínio',
    close: 'Fechar',
    gapsCount_one: '{{count}} lacuna conhecida',
    gapsCount_other: '{{count}} lacunas conhecidas',
    apPilot: {
      title: 'Piloto contas a pagar',
      description:
        'Ferramentas AP já descritas no catálogo MCP (descoberta via tools/list). Lacunas conhecidas ficam estruturadas no catálogo.',
      summary: '{{tools}} tools AP · {{gaps}} lacunas estruturadas',
    },
    inControl: {
      title: 'Você permanece no controle',
      description:
        'Depois de permitir o acesso, você (ou um administrador) pode aprovar, restringir ou revogar este agente por ferramenta a qualquer momento no ERP em Configurações → Agentes de IA conectados.',
    },
    allow: 'Permitir acesso',
    authorizing: 'Autorizando…',
    completeError: 'Não foi possível concluir a conexão. Tente novamente.',
    summary: {
      title: 'Autorizar agente de IA',
      description:
        'Revise o que este agente poderá fazer na sua conta Alchemy. Você poderá alterar essas permissões depois, a qualquer momento.',
      connected: 'Sua conta está conectada',
      viewTools: 'Ver as {{count}} ferramentas disponíveis',
      toolsDialogTitle: 'Ferramentas disponíveis',
      toolsDialogDescription:
        'Consulte a lista completa sem precisar analisar tudo antes de permitir o acesso.',
      availableTitle: 'O que será liberado',
      availableDescription:
        'O agente terá acesso somente ao que já está permitido para o seu usuário.',
      tools: 'ferramentas',
      readOnly: 'somente leitura',
      canChange: 'podem alterar dados',
      canConsultTitle: 'Pode consultar',
      canConsultDescription:
        'Consultar informações financeiras, operacionais e cadastrais nos domínios liberados.',
      canChangeTitle: 'Pode alterar',
      noChanges: 'Nenhuma ferramenta de alteração está disponível para este acesso.',
      changeDescription: '{{count}} ferramentas podem criar, atualizar ou arquivar dados.',
      changeDescriptionWithMoney:
        '{{count}} ferramentas podem criar, atualizar ou arquivar dados; {{money}} também podem mover dinheiro.',
      limitedAccess: 'Acesso limitado',
      additionalPermission: 'Uma permissão adicional',
      missingPermissions:
        'Algumas permissões do seu usuário ainda não estão liberadas: {{permissions}}.',
      nextStep: 'Próximo passo',
      readyTitle: 'Tudo certo para conectar?',
      readyDescription:
        'Ao continuar, o agente poderá solicitar essas ferramentas. A aprovação final de cada agente fica nas suas configurações.',
      reviewLater:
        'Você pode revisar ou revogar o acesso depois em Configurações → Agentes de IA conectados.',
    },
  },
} as const;

export const connectedAgentsEn = {
  page: {
    loadError: {
      title: 'Failed to load connected agents',
      description: 'Please refresh the page and try again.',
    },
    title: 'Connected AI agents',
    description:
      "AI agents (Claude, ChatGPT, and others) that connect to your data over MCP. Approve an agent and choose which tool groups it may use. Access is always also limited by the signed-in user's own permissions.",
    catalogLink: 'View MCP catalog',
    enforcementOff: {
      title: 'Per-agent enforcement is off',
      description:
        'Changes here are saved but not yet enforced for this organization. Enable per-agent enforcement to require approval before an agent can use a tool.',
    },
    empty:
      'No agents have connected yet. When an AI agent connects over MCP it will appear here for review.',
    pendingBanner: {
      title_one: '1 agent is waiting for review',
      title_other: '{{count}} agents are waiting for review',
      description:
        'Review the requested permissions below and approve or remove each new connection. Until approved, a pending agent cannot use your data when enforcement is on.',
    },
    table: {
      agent: 'User and client',
      status: 'Status',
      allowedTools: 'Allowed tools',
      lastSeen: 'Last seen',
      actions: 'Actions',
    },
    noEligibleTools: 'No tools are available for this connection.',
    lastScopeRequired: 'An approved agent must keep at least one tool enabled.',
    status: {
      pending: 'pending',
      approved: 'approved',
      revoked: 'revoked',
    },
    actions: {
      approve: 'Approve',
      revoke: 'Revoke',
      remove: 'Remove',
    },
    remove: {
      title: 'Remove {{name}}?',
      description:
        'This forgets the connection and deletes its saved permissions. If the same agent connects again it will reappear here for review. To permanently block an agent while keeping its history, use Revoke instead.',
      cancel: 'Cancel',
      confirm: 'Remove',
    },
    displayName: {
      session: 'MCP client (session)',
      generic: 'MCP client',
    },
    legacyUser: 'User not identified',
    legacyConnection: 'Legacy connection — reconnect the client',
    toast: {
      updated: 'Connected agent updated',
      updateError: 'Could not update the connected agent',
      removed: 'Connected agent removed',
      removeError: 'Could not remove the connected agent',
    },
  },
  connect: {
    title: 'Connect a new agent',
    description:
      "Connect ChatGPT or Claude to your ERP. You'll sign in with your Alchemy account and approve access — the agent then appears below for review.",
    mcpUrlLabel: 'MCP server URL',
    copy: 'Copy',
    copied: 'MCP URL copied',
    copyError: 'Could not copy — select and copy manually',
    authNotConfigured:
      "Note: the authorization server isn't fully configured in this environment yet.",
    urlNotConfigured: {
      title: 'MCP URL not configured',
      description: 'Ask your administrator to configure the MCP server URL for this environment.',
    },
    steps: {
      open: 'Open {{product}} → Settings → Connectors.',
      add: 'Add a custom connector and paste the MCP URL above.',
      signIn: 'Sign in with your Alchemy account and approve access.',
    },
    openConnectors: 'Open {{product}} connectors',
  },
  consent: {
    invalidLink: {
      title: 'Invalid connection link',
      description:
        'This page is opened automatically when you connect an AI agent. Start the connection from your AI client (ChatGPT or Claude).',
    },
    title: 'Authorize AI agent',
    description:
      'Signed in with your Alchemy account. These are the tool groups an AI agent can request.',
    requestedPermissions: 'Available permissions',
    catalogNote:
      'This is the full set of tools MCP offers. What each agent can actually use is controlled by you after it connects.',
    axis: { question: 'By question', domain: 'By domain', writes: 'Writes' },
    catalogEmpty: 'No cataloged tools are available for this access.',
    catalogError: 'Could not load the catalog.',
    missingAccess: 'Still needs access',
    details: 'View details',
    sampleQuestions: 'Sample questions',
    effect: 'Effect',
    effects: {
      READS_DATA: 'Read only',
      CHANGES_DATA: 'Changes data',
      MOVES_MONEY: 'Moves money',
    },
    limits: 'Limits',
    knownGaps: 'Known gaps',
    expansions: 'Expansions',
    composesWith: 'Composes with',
    resolvesIdsVia: 'Resolves IDs via',
    inputSchema: 'Inputs',
    outputSchema: 'Output',
    domains: 'Domains',
    domainLabels: {
      guide: 'MCP guide',
      ap: 'Accounts payable',
      ar: 'Accounts receivable',
      billing: 'Billing',
      budget: 'Budget',
      cashflow: 'Cash flow and treasury',
      fpa: 'FP&A',
      gl: 'General ledger',
      identity: 'Identity and users',
      org: 'Organization',
    },
    allTools: 'All',
    tools: 'Tools',
    toolsCount_one: '{{count}} tool',
    toolsCount_other: '{{count}} tools',
    accessGranted: 'You have access',
    selectTool: 'Select a tool',
    selectToolDescription: 'Choose a tool to view its complete reference.',
    emptyField: 'Not provided in the catalog',
    search: 'Search by name, question, or domain',
    close: 'Close',
    gapsCount_one: '{{count}} known gap',
    gapsCount_other: '{{count}} known gaps',
    apPilot: {
      title: 'Accounts payable pilot',
      description:
        'AP tools already described in the MCP catalog (discover via tools/list). Known gaps stay structured in the catalog.',
      summary: '{{tools}} AP tools · {{gaps}} structured gaps',
    },
    inControl: {
      title: 'You stay in control',
      description:
        'After you allow access, you (or an admin) can approve, restrict, or revoke this agent per tool anytime in the ERP under Settings → Connected AI agents.',
    },
    allow: 'Allow access',
    authorizing: 'Authorizing…',
    completeError: 'Could not complete the connection. Please try again.',
    summary: {
      title: 'Authorize AI agent',
      description:
        'Review what this agent can do in your Alchemy account. You can change these permissions later at any time.',
      connected: 'Your account is connected',
      viewTools: 'View the {{count}} available tools',
      toolsDialogTitle: 'Available tools',
      toolsDialogDescription:
        'Review the complete list without having to analyze everything before allowing access.',
      availableTitle: 'What will be available',
      availableDescription: 'The agent only gets access already available to your user.',
      tools: 'tools',
      readOnly: 'read-only',
      canChange: 'can change data',
      canConsultTitle: 'Can view',
      canConsultDescription: 'View financial, operational, and master data in the enabled domains.',
      canChangeTitle: 'Can change',
      noChanges: 'No data-changing tools are available for this access.',
      changeDescription: '{{count}} tools can create, update, or archive data.',
      changeDescriptionWithMoney:
        '{{count}} tools can create, update, or archive data; {{money}} can also move money.',
      limitedAccess: 'Limited access',
      additionalPermission: 'An additional permission',
      missingPermissions: 'Some permissions for your user are not enabled yet: {{permissions}}.',
      nextStep: 'Next step',
      readyTitle: 'Ready to connect?',
      readyDescription:
        'After continuing, the agent can request these tools. Final approval for each agent stays in your settings.',
      reviewLater: 'You can review or revoke access later under Settings → Connected AI agents.',
    },
  },
} as const;
